import React from "react";
import styled from "styled-components";
import "react-step-progress-bar/styles.css";
import DefaultInputClaroSocio from "../inputsClaroSocio/DefaultInputClaroSocio";
import ContactInputClaroSocio from "../inputsClaroSocio/ContactInputClaroSocio";
import AmountInputClaroSocio from "../inputsClaroSocio/AmountInputClaroSocio";
import ChipInputClaroSocio from "../inputsClaroSocio/ChipInputClaroSocio";
import SelectInputClaroSocio from "../inputsClaroSocio/SelectInputClaroSocio";
import CommisionModule from "../inputsClaroSocio/CommisionModule";
import SelectCardClaroSocio from "../inputsClaroSocio/SelectCardClaroSocio";
import CvvInputClaroSocio from "../inputsClaroSocio/CvvInputClaroSocio";
import DescriptionInputClaroSocio from "../inputsClaroSocio/DescriptionInputClaroSocio";
import { ClaroTooltip } from "@claropay/shared";
import ModalCardOk from "../../molecules/ModalCardOk";
import { mask } from "../GenericForm/utils/maskAmount";
import { floatToInteger } from "../GenericForm/utils/floatToInteger";
import { formatToCurrency } from "../GenericForm/utils/formatToCurrency";
import {
	getValueFromReference,
	handleValidation,
} from "../inputsClaroSocio/utils/index";
import {
	selectPaymentServiceContacts,
	selectOCRScannerData,
	getCanSendId,
	getHasCreditFromUrl,
	getBundleVersionFromUrl,
	getUserInfoSelector,
	getUserInfoLiteSelector,
	selectPaymentServiceConf
} from "../../../store/selectors/paymentsSelectors";
import ClaroButton from "../../atoms/ClaroButton";
import ClaroLoadBtn from "../../atoms/ClaroLoadBtn";
import {
	getPaymentMethods,
	getAmountOfTelcelPospago,
	setSelectedChipValues,
	getCommissionInfo,
	addContactToRecents,
	setCreditCardInfo,
	getPlans,
	setTrackSteps,
	getOCRScanner,
	executeTaggeo,
	setIsAnonimous,
	setReloadInfoAfterAddingCard,
	setShowAdvancementMiniBanner,
	setAdvancementPayMethod,
	setPaymentMethod
} from "../../../store/actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as sdkclaro from "@claro/sdkclaromicrofront";
import { GenericFormContext } from "../../../context/genericFormContext";
import ClaroPadding from "../../atoms/ClaroPadding";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import ClaroChipsBlock from "../../organisms/ClaroChipsBlock";
import ModalCardLoader from "../../molecules/ModalCardLoader";
import { getMessage, validateUserAgent} from "../utils";
import {
	AMOUNT_MIN_TO_USE_CREDIT,
	CREDIT_CLARO_PAY,
	AMIGO_PAGUITOS,
	servicesIdTAE,
	TELMEX,
	TELCEL_IDS,
	SERVICE_ID_TELCEL_RECARGA,
	CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE,
	CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO,
	SERVICE_ID_TELCEL_POSPAGO,
	ARCUS_BILLER_IDS,
	ADVANCEMENT_CLARO_PAY,
	SERVICE_ID_TELCEL_PLANES,
	ADVANCEMENT_CARD_INFO,
	TELCEL_POSPAGO_MICROAPP_ID,
	SERVICE_ID_TELCEL_PAQUETES_POSPAGO,
	CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS
} from "../../../constants";
import { calculateOriginPayment } from "../GenericForm/utils/calculateOriginPayment";
import ModalValidationNumberAP from "../ModalValidationNumberAP";
import { findPaymentMethodFromFluxAddCard } from "./utils.js/findPaymentMethodFromFluxAddCard";
import ButtonBoxContainer from "../../containers/ButtonBoxContainer";
import SelectCardAnonimous from "../inputsClaroSocio/SelectCardClaroSocio/selectCardAnonimous";
import ModalCardHE from "../../molecules/ModalCardHE";
import { getHasDomiciliation } from "../../../store/actions/domiciliation.js";
import { findReference } from "./utils.js/findReference.js";
import { existConfigFavorites } from "../utils";
import { buttonDomiciliationConfigExist } from "../utils";
import Snackbar from "../Snackbars/completeInformation.js";

const Container = styled.div`
  width: 100%;
  margin-bottom:  ${props => props.os == "android" ? "0px" : "30%"};
  position: relative;
  z-index: 0;
`;

const pospagoAlertInitialState = {
	pospagoAlertText: "¡Uy, algo pasó!",
	pospagoAlertButtonText: "Volver a intentar",
	pospagoAlertTextDetail: "No pudimos consultar tu saldo.",
	pospagoAlertTextLink: "Salir",
	pospagoHandleReintent: true,
};

const Text_CS_TooltipTitle = () => {
	return (
		<span>
			Encuentra la línea de captura
			<br />
			en tu recibo como indica la guía
		</span>
	);
};


class BodyPaymentFormClaroSocio extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.buttonSubmitRef = React.createRef()

		const { 
            paymentMethods
        } = this.props

        const isAnonimous = this.props.isAnonimous || (paymentMethods.cardList && paymentMethods.cardList.length === 0 && !paymentMethods.hasN2)
            ? true
            : false;

		this.state = {
			dataConfigInputs: this.props.dataConfigInputs,
			addCloseEfect: false,
			textTitleTooltip: "",
			textTitleTooltipMargin: "",
			imgTooltip: "",
			imgTooltipPosition: null,
			imgTooltipWidth: null,
			openToolTip: false,
			openSelectCardClaroSocio: false,
			valueSelectInput: "",
			destAccountIdValue: "",
			contactsValue: "",
			valueCardId: "",
			valuetChipInput: "",
			valueChipProductId: "",
			valueCvv: "",
			valueDescription: "",
			mark: "",
			isValidAmount: false,
			isValidOcr: true,
			isValidContacts: true,
			isValidSelectPaymentMethod: true,
			isValidCvv: true,
			isValidDescription: true,
			isValidCardId: true,
			setFromOcrScannerData: false,
			setAmountTelcelPospago: false,
			setContactsValue: true,
			commissionData: [],
			setCommissionRules: true,
			_item: [],
			openModalTelcel: false,
			imgModalTelcel:
				"data:image/png;base64,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",
			titleModalTelcel: "TITLE",
			subtitleModalTelcel: "",
			setDefaultAmount: true,
			setDefaultOcrValue: true,
			setDefaultContactsValue: true,
			setDefaultSelectValue: true,
			visibleInputCvv: false,
			buttonState: {
				disabled: true,
			},
			buttonText: "Continuar",
			inputsvalidated: [],
			openModalUpdateCard: false,
			heightTooltip: "85%",
			heightImg: "",
			fontSizeTitleTooltip: "12px",
			fontColorTooltip: "#B2B2B2",
			textSubtitle: "",
			responseCodeMessage: "",
			responseCode: "",
			discount: [],
			totalCommission: 0,
			setValueCvv: false,
			limitCountPaymentMethodsCall: 2,
			openModalCloseMicroApp: false,
			openModalGoToHome: false,
			disabledAmountInput: false,
			scanErrorDestAccountIdValue: "",
			scanError: false,
			discountCredit: {
				amountWithoutDiscount: 0,
				discountPercentage: 0,
				discountAmount: 0,
				discountFixedAmount: 0,
				amountWithoutCommissions: 0,
			},
			inquiryTelmexId: "",
			amountMinAlert: false,
			marginButtonContinue: "4%",
			pospagoAlertState: pospagoAlertInitialState,
			buttonTextTelcel: "Entendido",
			errorCode36_TELMEX: {
				subTitleStyle: {
					color: "red",
					margin: "0.5rem 0rem 0rem 0rem",
				},
				text: "El número de cliente es incorrecto",
				visible: false,
			},
			itemDistpatchGetAmount: false,
			itemDistpatchGetAmountLength: 0,
			modalValidationNumberAPIsOpen: false,
			modalValidationNumberAPCase: 0, // 1 -> TECEL REDIRECT TO AP | 2 -> AP REDIRECT TO TELCEL
			modalValidationNumberAPTitle: 'TITLE',
			modalValidationNumberAPSubtitle: 'SUBTITLE',
			ModalValidationNumberAPBtn1Text: 'BTN1',
			ModalValidationNumberAPBtn2Text: 'BTN2',
			setAutomaticOnclick: true,
			isDisabledButtonArcusGetAmount: true,
			openAlertNoPendingAmount: false,
			initialCreditCardInfo: this.props.creditCardInfo,
			openSelectCardAnonimous: false,
			isAnonimous: isAnonimous,
			isOpenModalCardHE: false,
			userInfoLiteState: {},
			fromListFavorites: false,
			isOpenCompleteInformationSnackBar: false,
			submitFormAutomaticForAnonimous: false
		};
	}

	componentDidMount() {
		
		const {
			dataConfigInputs,
			sdkVersion,
			serviceInfo,
			productIdFromPlan,
			amountPlan,
			serviceId,
			selectedChipValues,
			lineNumber,
			isClaroPartner,
			paramsNewOfferTelcel,
			contactNumber,
		} = this.props;
		
		isClaroPartner && servicesIdTAE.includes(serviceId)
			? this.setState({ buttonText: 'Siguiente' })
			: this.setState({ buttonText: this.state.buttonText });

		if (
			sdkVersion !== undefined && 
			(!this.state.isAnonimous || this.props.addCardFormData.handleSetDefaultPaymentMethod)
		) {
			this.setDefaultPaymentMethod();
		}

		if (serviceInfo.logicType == "claroVideo") {
			this.setState({
				buttonText: "Contrátalo  Ahora",
				showClaroVideoTitle: true,
			});
		}

		this.isButtonSubmitDisabled();
		if (productIdFromPlan && serviceId !== SERVICE_ID_TELCEL_RECARGA) {
			this.setState({ valueChipProductId: productIdFromPlan });
			this.props.setSelectedChipValues(productIdFromPlan, amountPlan);
			this.context.getAmountFromOcrData(amountPlan);
		}
		if (serviceId == 143 && serviceInfo.planInformationQuery) {
			this.props.getPlans(serviceId, serviceInfo.categoryPlansId);
		}
		if (serviceId == 113) {
			this.context.getAmountFromOcrData(0);
			const object = selectedChipValues;
			if (object) {
				Object.keys(object).forEach((key) => (object[key] = null));
			}
		}
		if (serviceInfo.logicType == "sears" && amountPlan) {
			this.context.getAmountFromOcrData(formatToCurrency(amountPlan));
			this.setState({ marginButtonContinue: "4% 20%" });
		}
		// Bandera para evitar que al negar permisos de contactos se regrese mas de una pantalla en la navegación
		window.backContacts = false;

		if (
			(lineNumber && lineNumber.length === 10 && serviceId == TELMEX) ||
			(lineNumber && lineNumber.length === 10 && serviceId == SERVICE_ID_TELCEL_POSPAGO) ||
			(paramsNewOfferTelcel && serviceId === SERVICE_ID_TELCEL_POSPAGO) 
		) {
			const lineNumberValue = paramsNewOfferTelcel ? paramsNewOfferTelcel.line : lineNumber
			this.setState({
				destAccountIdValue: lineNumberValue,
				isValidOcr: true,
				setAmountTelcelPospago: true,
				setDefaultOcrValue: false,
			});
			this.addItemValidated("isValidOcr");
			if(!paramsNewOfferTelcel) {
				this.props.getAmountOfTelcelPospago(lineNumberValue, serviceId);
				if(serviceId === SERVICE_ID_TELCEL_POSPAGO && !this.props.isContainerTelcel){
					this.props.getHasDomiciliation(lineNumber, serviceId);
				}
			}
		}
		if (
			serviceId === SERVICE_ID_TELCEL_RECARGA || 
			serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE
			) {
			if (
				isNaN(lineNumber) === false &&
				lineNumber &&
				lineNumber.length === 10
			) {
				this.setState({
					contactsValue: lineNumber,
					setContactsValue: false,
					setDefaultContactsValue: false,
					destAccountIdValue: lineNumber, // esto porque el tipo de field es contact en lugar ade OCR
				});
				this.addItemValidated("isValidContacts");
			}
			const {paymentAmountFromUrl, productIdFromUrl, setSelectedChipValues } = this.props

			if(serviceId === SERVICE_ID_TELCEL_RECARGA && paymentAmountFromUrl && productIdFromUrl){
				setTimeout(() => {
					setSelectedChipValues(productIdFromUrl, paymentAmountFromUrl);
					this.handleInputClick(event, "select-chips", [], paymentAmountFromUrl, productIdFromUrl)
				}, 1200);
			}
		}

		if (paramsNewOfferTelcel) {
			const { line, cvv: { cvvValue, isRequiredCvv } } = paramsNewOfferTelcel
			if (
				serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
				serviceId === SERVICE_ID_TELCEL_RECARGA ||
				(serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO && serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS)
			) {
				this.setState({
					contactsValue: contactNumber ? contactNumber : line,
					setContactsValue: false,
					setDefaultContactsValue: false,
					destAccountIdValue: contactNumber ? contactNumber : line,

				});
				this.addItemValidated("isValidContacts");
			}
			if (isRequiredCvv) {
				this.setState({ valueCvv: cvvValue, setValueCvv: true });
				this.addItemValidated("isValidCvv");
			} else {
				this.deleteItemValidated("isValidCvv");
			}
		}

		// Taggeo a facturadores arcus 
		if (ARCUS_BILLER_IDS.includes(this.props.serviceId)) {
			this.taggeoArcus("View");
		}

	}

	handleSetAdvancementPayMethod(cost=null) {
		const {
			paymentMethods, serviceId,
			userInfoLite : {advancePayment}, setShowAdvancementMiniBanner
		} = this.props
		const canShowSaneckBar = paymentMethods && paymentMethods.hasAdvancement && advancePayment && advancePayment.creditAmount 
			if (serviceId === SERVICE_ID_TELCEL_RECARGA) {
				if (canShowSaneckBar && cost !== null && cost <= advancePayment.creditAmount) {
					setShowAdvancementMiniBanner(true)
				} else {
					if (paymentMethods && (paymentMethods.cardList.length > 0 || paymentMethods.hasN2)) {						
						this.setDefaultPaymentMethod();
						setShowAdvancementMiniBanner(false)
					}
				}
			}
	}

	validateActiveN2 = () => {
		return this.props.sdkVersion < "1.0.147" ? true : this.props.activeN2;
	};

	setStepTrack = (step) => {
		if (this.props.trackId) {
			this.props.setTrackSteps(this.props.trackId, `${step}`);
		}
	};

	componentDidUpdate(prevProps, prevState) {
		const {
			setPaymentMethod,
			setPaymentMethodInfo, 
			paymentMethods,
			serviceId, 
			isClaroPartner,
			getPaymentMethods,
			setAdvancementPayMethodValue,
			reloadInfoAfterAddingCard,
			isAnonimous,
			setAdvancementPayMethod
		} = this.props
		const cardList = paymentMethods && paymentMethods.cardList ? paymentMethods.cardList : [];
		if(setPaymentMethodInfo && setPaymentMethodInfo !== prevProps.setPaymentMethodInfo){
			getPaymentMethods(serviceId, isClaroPartner);
		}
		if(
			(paymentMethods !== prevProps.paymentMethods) &&
			cardList.length > 0 &&
			!reloadInfoAfterAddingCard &&
			setPaymentMethodInfo 
		){
			this.handleInputClick(
				event, 
				"cardId", 
				findPaymentMethodFromFluxAddCard(setPaymentMethodInfo, cardList)
			);	
			setPaymentMethod(undefined);
		}
		if (prevProps.isAnonimous !== isAnonimous) {
			if (cardList) {
				this.setState({ isAnonimous: false });
				this.setDefaultPaymentMethod();
			}	
			this.props.setReloadInfoAfterAddingCard(false);
		}
		if(prevProps.setAdvancementPayMethodValue !== setAdvancementPayMethodValue){
			if(setAdvancementPayMethodValue){
				// Poner Adelanto como método seleccionado
				this.handleInputClick(event, "cardId", ADVANCEMENT_CARD_INFO);
				setAdvancementPayMethod(false)
			}
		}

		const { userInfoLite } = this.props;
		const { userInfoLiteState } = this.state;
		if (userInfoLite && userInfoLiteState && 
		userInfoLite["claro-profile.person.claroid"] !== userInfoLiteState["claro-profile.person.claroid"]) {
			const { hasCredit, canSendId, userInfoLite, } = this.props;
			this.setState({
				userInfoLiteState: userInfoLite,
			})
			if (userInfoLite && userInfoLite.credit &&
				userInfoLite.credit.score &&
				userInfoLite.credit.score !== null &&
				userInfoLite.credit.score !== false &&
				userInfoLite.credit.score !== "false" &&
				userInfoLite.credit.creditAmount &&
				userInfoLite.credit.creditAmount !== null &&
				userInfoLite.credit.creditAmount !== "0" &&
				userInfoLite.credit.isOnboarding === "true" &&
				userInfoLite.credit.accepted === "false"
			&& canSendId && this.props.serviceId !== AMIGO_PAGUITOS) {
				sdkclaro.getInstance().showCreditSnackBar(
					"snackbar_credit_services",
					() => { },
					() => { }
				);
			}
		}

		if (prevProps.isLoadingCommisSionRules !== this.props.isLoadingCommisSionRules) {
			if (this.props.isLoadingCommisSionRules) {
				this.setState({ buttonState: {disabled: true} })
			} else {
				this.isButtonSubmitDisabled();
			}
		}

		if (prevProps.creditCardInfo !== this.props.creditCardInfo && this.props.creditCardInfo) {
			if (this.props.validateIfSentToTicket) {
				let inputsForValidationArray = this.props.dataConfigInputs.filter(
					(element) => {
						if (element.field) {
							return (
								(element.field.input.value == "" ||	element.field.input.value == undefined) &&
								element.field.input.logicType == undefined &&
								element.constraints &&
								element.id !== "cvv"
							);
						}
					}
				);
				let inputsValidatedArray = this.state.inputsvalidated.filter(element => element !== "isValidCvv");
				const fillFields = inputsForValidationArray.length == inputsValidatedArray.length ? true : false;

				if (!fillFields) {
					this.props.handleShowLoaderWaitSubmit(false);
					this.handleIsOpenCompleteInformationSnackBar(true);
					let exitMap = false;
					inputsForValidationArray.map(input => {
						if (
							input.constraints &&
							input.field &&
							input.field.input &&
							input.field.input.name &&
							input.id !== "cardId" &&
							!exitMap
						) {
							const constraints = typeof input.constraints === "object" && Object.keys(input.constraints).length >= 1
								? input.constraints[0]
								: input.constraints
							const regex = new RegExp(constraints);
							const name = input.field.input.name;
							const inputDom = document.querySelector(`input[name=${name}]`);
							if (inputDom &&  !regex.test(inputDom.value)) {
								inputDom.focus();
								exitMap = true;
							}
						}
					})
				} else {
					this.setState({ submitFormAutomaticForAnonimous: true })
				}
				this.props.handleValidateIfSentToTicket(false);					
			}
		}

		if (prevState.buttonState.disabled !== this.state.buttonState.disabled ) {
			if (!this.state.buttonState.disabled && this.state.submitFormAutomaticForAnonimous) {
				console.log('SUBMIT__')
				this.setState({ submitFormAutomaticForAnonimous: false });
				this.submitFormToPayTopic();
			}
		}

	}

	handleIsOpenCompleteInformationSnackBar = (value) => {
		console.log('SNACKBAR__', value)
		this.setState({isOpenCompleteInformationSnackBar: value});
	}

	setDefaultPaymentMethod = () => {
		let cardInfo = {};
		let defaultItemPaymentMethod = [];
		const {creditCardInfo, paymentMethods} = this.props
		if (creditCardInfo && creditCardInfo.value != ADVANCEMENT_CLARO_PAY ) {
			cardInfo = creditCardInfo;
		} else {
			defaultItemPaymentMethod = paymentMethods.cardList.map(
				(item, index) => {
					if (item.isDefault != "0") {
						return item;
					} else {
						return false;
					}
				}
			);

			if (paymentMethods.hasN2 && this.validateActiveN2()) {
				if (defaultItemPaymentMethod[0]) {
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					cardInfo = {
						value: "claro-pay",
						mark: "999",
						type: 0,
						lastDigits: " ",
						update: false,
					};
				}
			} else {
				if (defaultItemPaymentMethod[0]) {
					cardInfo = {
						value: defaultItemPaymentMethod[0].cardId,
						mark: defaultItemPaymentMethod[0].card.mark,
						type: defaultItemPaymentMethod[0].card.type,
						lastDigits: defaultItemPaymentMethod[0].card.lastDigits,
						update: false,
					};
				} else {
					paymentMethods.cardList[0];
					cardInfo = {
						value: paymentMethods.cardList[0].cardId,
						mark: paymentMethods.cardList[0].card.mark,
						type: paymentMethods.cardList[0].card.type,
						lastDigits: paymentMethods.cardList[0].card.lastDigits,
						update: false,
					};
				}
			}
		}
		this.setState({initialCreditCardInfo: !this.state.initialCreditCardInfo ? cardInfo : this.state.initialCreditCardInfo})
		this.handleInputClick(event, "cardId", cardInfo);
	};

	getCommissions = (cardIdValue, valueToCommissions) => {
		const { contactsValue, destAccountIdValue } = this.state;	
		if (cardIdValue) {
			let isClaroPay = cardIdValue == "claro-pay" ? true : false;
			let valueAmountString = parseFloat(valueToCommissions.replace(/,/g, ""));
			let isClaroPartner = this.props.isClaroPartner ? true : false;

			if (
				valueAmountString > 0 &&
				this.props.sdkVersion !== undefined &&
				cardIdValue != CREDIT_CLARO_PAY && cardIdValue != ADVANCEMENT_CLARO_PAY
			) {
				this.props.getCommissionInfo(
					this.props.serviceId,
					"",
					valueAmountString,
					isClaroPay,
					cardIdValue,
					this.props.sdkVersion,
					isClaroPartner,
					this.props.trackId,
					contactsValue ? contactsValue : destAccountIdValue,
				);
				this.setState({ setCommissionRules: true });
			}
		}
		
	};

	handleInputChange = (event, type) => {
		const itemName = event.target.name;
		let itemValue = event.target.value;
		let _item = _.find(this.props.dataConfigInputs, ["id", itemName]);
		const itemValueLength = itemValue.length;
		const initialPhoneNumbers = itemValue.substring(0, 2);
		let launchGetAmountTelcel = true;

		this.setState({ 
			itemDistpatchGetAmount: _item.distpatchGetAmount ? true : false,
			itemDistpatchGetAmountLength: _item.distpatchGetAmountLength ? _item.distpatchGetAmountLength : this.state.itemDistpatchGetAmountLength
		});

		const bundleVersionFromUrl = parseInt((this.props.bundleVersion).toString().replaceAll('.', ''));
		const minFunctionalBundleVersion = parseInt((process.env.REACT_APP_BUNDLE_VERSION).replaceAll('.', ''));
		const launchModalValidationAP = bundleVersionFromUrl >= minFunctionalBundleVersion ? true : false;

		if (
			TELCEL_IDS.includes(this.props.serviceId) &&
			itemValueLength === 10 &&
			initialPhoneNumbers === '10' &&
			!this.props.isClaroPartner &&
			launchModalValidationAP
		) {
			this.setState({
				modalValidationNumberAPCase: 1,
				modalValidationNumberAPTitle: 'El número que ingresaste pertenece a un Amigo Paguitos',
				modalValidationNumberAPSubtitle: '¿Quieres pagarlo?',
				ModalValidationNumberAPBtn1Text: 'No',
				ModalValidationNumberAPBtn2Text: 'Sí',
				modalValidationNumberAPIsOpen: true
			})
			this.modalValidationNumberAPTaggeo('View alert', 1);
			launchGetAmountTelcel = false;
		}

		if (
			this.props.serviceId === AMIGO_PAGUITOS &&
			itemValueLength === 10 &&
			initialPhoneNumbers !== '10' &&
			!this.props.isClaroPartner &&
			launchModalValidationAP
		) {
			this.setState({
				modalValidationNumberAPCase: 2,
				modalValidationNumberAPTitle: 'El número que ingresaste pertenece a un plan Telcel',
				modalValidationNumberAPSubtitle: '¿Quieres pagarlo?',
				ModalValidationNumberAPBtn1Text: 'No',
				ModalValidationNumberAPBtn2Text: 'Sí',
				modalValidationNumberAPIsOpen: true
			})
			this.modalValidationNumberAPTaggeo('View alert', 2);
			launchGetAmountTelcel = false;
		}
		const { truncateValue, truncateValueClaroSocio } = _item.field.input;
		switch (event.target.name) {
			case "amount":
				let maxAmount = _item.range ? _item.range.max : 0;
				let maskedValue = mask(itemValue, maxAmount);
				const { getAmountFromOcrData, handleSetAmountFromInput } = this.context;
				getAmountFromOcrData(maskedValue.value);
				handleSetAmountFromInput(true);
				if (!this.props.amountPlan) {
					this.inputValidation(
						parseFloat(itemValue.replace(/,/g, "")),
						_item,
						"isValidAmount"
					);
				}
				this.setState({ setDefaultAmount: false });

				this.getCommissions(this.state.valueCardId, maskedValue.value);
				break;
			case "destAccountId":
				if (truncateValue) {
					const { isClaroPartner } = this.props;
					const truncatevalueConfig =
						isClaroPartner && truncateValueClaroSocio
							? truncateValueClaroSocio
							: truncateValue;
					itemValue = event.target.value.substr(0, truncatevalueConfig);
				}
				if (type == "ocr") {
					if (_item.uppercase) {
						itemValue = itemValue.toUpperCase();
					}
					this.setState({
						destAccountIdValue: itemValue,
						setFromOcrScannerData: false,
						setDefaultOcrValue: false,
						scanErrorDestAccountIdValue: itemValue,
						errorCode36_TELMEX: {
							...this.state.errorCode36_TELMEX,
							visible: false,
						},
					});
					this.inputValidation(itemValue, _item, "isValidOcr");
					if (_item.distpatchGetAmount && launchGetAmountTelcel && this.state.inputsvalidated.includes("isValidOcr")) {
						if (ARCUS_BILLER_IDS.includes(this.props.serviceId)) {
							this.setState({
								isDisabledButtonArcusGetAmount: _item.distpatchGetAmountLength && itemValue.length == _item.distpatchGetAmountLength
									? false
									: true
							});
							if (_item.distpatchGetAmountLength && itemValueLength == _item.distpatchGetAmountLength && !this.props.isContainerTelcel) {
								this.props.getAmountOfTelcelPospago(
									itemValue,
									this.props.serviceId
								);
								this.setState({ setAmountTelcelPospago: true });
							}

						} else {
							if (itemValueLength === 10) {
								this.props.getAmountOfTelcelPospago(
									itemValue,
									this.props.serviceId
								);
								this.setState({ setAmountTelcelPospago: true });
								this.setStepTrack("CS01");
								if(this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO && !this.props.isContainerTelcel){
									this.props.getHasDomiciliation(itemValue, this.props.serviceId);
								}
							}
						}
					}
				}
				this.setState({fromListFavorites: false})
				if (type == "contacts") {
					let contactInputValue = itemValue.replace(/\./g, "");
					const { setMask } = _item.field.input;
					const { isClaroPartner } = this.props;
					if (isClaroPartner && setMask) {
						contactInputValue = contactInputValue
							.replace(/\D/g, "")
							.replace(/(\d{2})(\d{1,2})/, "$1 $2")
							.replace(/(\d{4})(\d{1,2})/, "$1 $2");
					}
					this.setState({
						contactsValue: contactInputValue,
						setContactsValue: false,
						setDefaultContactsValue: false,
						destAccountIdValue: contactInputValue,
					});
					this.inputValidation(itemValue, _item, "isValidContacts");
				}

				break;
			case "cardId":
				break;
			case "cvv":
				let value = itemValue;
				if (itemValue.length > 4) {
					value = itemValue.substr(0, 4);
				}
				this.inputValidation(value, _item, "isValidCvv");
				this.setState({ valueCvv: value, setValueCvv: true });
				break;
			case "description":
                if (truncateValue) {
                    itemValue = event.target.value.substr(0, truncateValue)
                }

				itemValue = itemValue.replace(/\p{Extended_Pictographic}/u, "");

				this.inputValidation(itemValue, _item, "isValidDescription");
				this.setState({ valueDescription: itemValue });
				break;
		}
	};

	inputValidation(itemValue, _item, inputValid) {
		const { isClaroPartner } = this.props;
		const { constraintsClaroSocio, constraints } = _item;
		const constraintsValue =
			isClaroPartner && constraintsClaroSocio
				? constraintsClaroSocio
				: constraints;
		if (constraintsValue) {
			if (handleValidation(itemValue, constraintsValue[0])) {
				this.setState({ [inputValid]: true });
				this.addItemValidated(inputValid);
			} else {
				this.deleteItemValidated(inputValid);
				this.setState({ [inputValid]: false });
			}
		}
		return true;
	}

	addItemValidated(itemName) {
		if (!this.state.inputsvalidated.includes(itemName)) {
			this.state.inputsvalidated.push(itemName);
			setTimeout(() => {
				this.isButtonSubmitDisabled();
			}, 200);
		}
	}

	deleteItemValidated(itemName) {
		let deleteInputsValidated = this.state.inputsvalidated.filter(function (
			item
		) {
			return item !== itemName;
		});
		this.setState({ inputsvalidated: deleteInputsValidated });
		setTimeout(() => {
			this.isButtonSubmitDisabled();
		}, 200);
	}

	taggeoArcusSaldoCero = (action,alert_id) => {
		const { executeTaggeo } = this.props;
		executeTaggeo({
			eventName: "Service_payment",
			step: "Formulario de pago",
			action: action,
			alert_id: alert_id
		});
	}
	taggeoArcus = (action) => {
		const { executeTaggeo } = this.props;
		executeTaggeo({
			eventName: "Service_payment",
			step: "Formulario de pago",
			action: action,
			service: this.props.serviceName
		});
	}
	modalValidationNumberAPTaggeo = (action, taggeoCase) => {
		const { executeTaggeo } = this.props;
		const params = {
			step: taggeoCase === 1 ? 'Formulario de pago' : 'Formulario Amigo Paguitos',
			action: action,
			Id_alert: taggeoCase === 1 ? 'Telcel a Amigo Paguitos' : 'Amigo Paguitos a plan telcel',
			service: this.props.serviceName
		}
		executeTaggeo(params);
	}
	taggeo = (action) => {
		const { originOfPayment, executeTaggeo, serviceId, tagServiceId, serviceInfo } = this.props;
		const { categoryPlansId } = serviceInfo

		if (
			(
				originOfPayment &&
				originOfPayment !== "Home" &&
				serviceId === TELMEX
			) ||
			serviceId === AMIGO_PAGUITOS ||
			categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO ||
			categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
			serviceId === SERVICE_ID_TELCEL_POSPAGO
		) {
			executeTaggeo({
				step: "Formulario de pago",
				action: action,
				service: tagServiceId,
				origin: calculateOriginPayment(originOfPayment),
			});
		}
	};
	handleInputClick = (event, typeInput, cardInfo, value, productId) => {
		const {setCreditCardInfo, setAdvancementPayMethod} = this.props
		if (typeInput == "cardId") {
			setCreditCardInfo(cardInfo);				
			this.setState({ openSelectCardClaroSocio: false, setValueCvv: false });
			if (cardInfo.value == "agregar-targeta") {
				this.setState({ valueSelectInput: "", mark: "", valueCardId: "" });
				sdkclaro.getInstance().openWallet("openWallet");
				this.deleteItemValidated("isValidCardId");
			} else {
				if (cardInfo.update == true) {
					this.setState({
						openModalUpdateCard: true,
						valueSelectInput: "",
						mark: "",
						valueCardId: cardInfo.value,
					});
				} else {
					this.setState({
						valueSelectInput: cardInfo.lastDigits,
						valueCardId: cardInfo.value,
						mark: cardInfo.mark,
					});

					let valueToCommissions = this.context.ocrAmountValue;
					let _item_amount = _.find(this.props.dataConfigInputs, [
						"id",
						"amount",
					]);
					if (_item_amount) {
						if (
							_item_amount.field.input.value &&
							_item_amount.field.input.value != ""
						) {
							valueToCommissions = _item_amount.field.input.value;
						}
					}

					if (this.props.amountPlan) {
						valueToCommissions = this.props.amountPlan;
					}
					if (this.props.selectedChipValues && !this.props.amountPlan) {
						valueToCommissions = this.props.selectedChipValues.amountValue;
					}
					this.getCommissions(cardInfo.value, String(valueToCommissions));
					this.addItemValidated("isValidCardId");
					if (cardInfo.value == CREDIT_CLARO_PAY || cardInfo.value === ADVANCEMENT_CLARO_PAY) {
						setTimeout(() => {
							this.addItemValidated("isValidCvv");
							this.setState({ visibleInputCvv: false });
						}, 500);
					
					}
					if(cardInfo.value !== ADVANCEMENT_CLARO_PAY){
						setAdvancementPayMethod(false)
					}
				}
			}
		}

		if (typeInput == "select-chips") {
			this.getCommissions(this.state.valueCardId, String(value));
			this.setState({ valuetChipInput: value, valueChipProductId: productId });
			this.props.setSelectedChipValues(productId, value);
			this.context.getAmountFromOcrData(value);
			this.addItemValidated("isValidAmount");
			this.handleSetAdvancementPayMethod(value);
		}

		if (typeInput == "setFocusFieldAmount") {
			document
				.getElementById("pagoDeServicios_amount_" + this.props.serviceName)
				.focus();
			this.taggeo("Click Editar monto");
		}

		if (typeInput == "setAmountTelcelPostago") {
			this.taggeo("Click Consultar saldo");
			this.setStepTrack("CS01");
			if (this.state.destAccountIdValue.length == 10) {
				this.props.getAmountOfTelcelPospago(
					this.state.destAccountIdValue,
					this.props.serviceId
				);
				this.setState({ setAmountTelcelPospago: true });
			}
		}

		if (typeInput == "getAmountArcusBillers") {
			if (!this.state.isDisabledButtonArcusGetAmount) {
				this.taggeoArcus("Click Consultar saldo")

				const item = this.props.dataConfigInputs.find(element => element.distpatchGetAmount);

				if (item) {
					const distpatchGetAmountLength = item.distpatchGetAmountLength;
					const referenceLength = this.state.destAccountIdValue.length;
					
					if (distpatchGetAmountLength && distpatchGetAmountLength === referenceLength) {
						this.props.getAmountOfTelcelPospago(
							this.state.destAccountIdValue,
							this.props.serviceId
						);
						this.setState({ setAmountTelcelPospago: true });
					}
				}				
			}			
		}
	};
	isButtonSubmitDisabled() {
		let inputsForValidationArray = this.props.dataConfigInputs.filter(
			(element) => {
				if (element.field) {
					if (this.props.sdkVersion !== undefined) {
						return (
							(element.field.input.value == "" ||
								element.field.input.value == undefined) &&
							element.field.input.logicType == undefined &&
							element.constraints
						);
					} else {
						return (
							(element.field.input.value == "" ||
								element.field.input.value == undefined) &&
							element.constraints &&
							element.id != "cardId" &&
							element.id != "cvv"
						);
					}
				}
			}
		);
		let inputsValidated = this.state.inputsvalidated.length;
		let inputsForValidation = inputsForValidationArray.length;
		if (inputsForValidation == inputsValidated) {
			this.setState({ buttonState: { disabled: false } });
		} else {
			this.setState({ buttonState: { disabled: true } });
		}
	}

	handleInputButtonFunction = (event, type) => {
		const { isAnonimous } = this.state;
		switch (type) {
			case "contacts":
				this.setStepTrack("V1-CONTACTS-TFR-P2P");
				this.taggeo("Click Agenda");
				break;
			case "ocr":
				this.setStepTrack("V1-SCAN-QR-TFR-P2P");
				let _item = _.find(this.props.dataConfigInputs, [
					"id",
					"destAccountId",
				]);
				this.setState({
					setFromOcrScannerData: true,
					_item: _item,
					setDefaultOcrValue: false,
				});
				this.props.getOCRScanner(
					this.props.isClaroPartner,
					this.props.imgTooltip,
					_item.field.input.maxlength
				);
				this.context.handleSetAmountFromInput(false);
				break;
			case "select":
				this.taggeo("Click Método de pago");
				this.setState({ setDefaultSelectValue: false });
				!isAnonimous ? this.getSelectPayment() : this.getSelectPaymentAnonimous();
				break;
		}
	};

	getSelectPayment = (event) => {
		const { getPaymentMethods, serviceId, isClaroPartner } = this.props;
		getPaymentMethods(serviceId, isClaroPartner);
		this.setState({ openSelectCardClaroSocio: true });
		this.setStepTrack("COMP01");
	};

	getSelectPaymentAnonimous = (event) => {
		this.setState({ openSelectCardAnonimous: true });
	};

	handleClickTooltip = (event, type) => {
		let dataConf = this.props.dataConfigInputs.find(config => config.id === 'buttonBox');
    	let favOps = dataConf ? dataConf.cp.find(input => input.id === 'favoritos') : null;
		
		let textTitleTooltip = "";
		let imgTooltip = "";
		let heightTooltip = "";
		let heightImg = "";
		let fontSizeTitleTooltip = "";
		let fontColorTooltip = "";
		let textSubtitle = "";
		let imgTooltipPosition = (this.props.imgTooltipPosition && this.props.imgTooltipPosition !== "") ? this.props.imgTooltipPosition : null;
		let imgTooltipWidth = (this.props.imgTooltipWidth && this.props.imgTooltipWidth !== "") ? this.props.imgTooltipWidth : '272px';

		switch (type) {
			case "ocr":
				if (this.props.isClaroPartner) {
					textTitleTooltip = <Text_CS_TooltipTitle />;
				}else if (this.props.canManageFavorites && favOps && !!favOps.textTitleTooltipFavoritos && !this.props.isContainerTelcel) {
					textTitleTooltip= favOps.textTitleTooltipFavoritos;
					imgTooltipPosition = favOps.imgTooltipPositionFav;
					imgTooltipWidth = favOps.imgTooltipWidthFav;
				} else {
					textTitleTooltip =
						this.props.textTitleTooltip &&
							this.props.textTitleTooltip.length > 0
							? this.props.textTitleTooltip
							: "En el siguiente ejemplo encontraras los datos necesarios para pagar tu servicio.";
				}
				imgTooltip = this.props.canManageFavorites && favOps && !!favOps.imgTooltipFavoritos && !this.props.isContainerTelcel && !this.props.isClaroPartner ? favOps.imgTooltipFavoritos : this.props.imgTooltip;
				heightTooltip = "85%";
				heightImg = validateUserAgent() === "android" ? "75%" : "70%";
				fontSizeTitleTooltip = "13px";
				fontColorTooltip = "#B2B2B2";
				textSubtitle = "";
				break;
			case "cvv":
				textTitleTooltip = "Tarjeta Visa y Master Card";
				imgTooltip = this.props.isContainerTelcel ? "/images/cvv.png" : "/images/cvv.svg";
				heightTooltip = "58%";
				heightImg = validateUserAgent() === "android" ? "43%" : "38%";
				fontSizeTitleTooltip = this.props.isContainerTelcel ? "18px" : "15px";
				fontColorTooltip = this.props.isContainerTelcel ? "#000000" : "#161616";
				textSubtitle =
					"El número de tres dígitos ubicado en el reverso de tu tarjeta de crédito o débito.";
				break;
		}

		this.setState({
			addCloseEfect: false,
			openToolTip: true,
			textTitleTooltip: textTitleTooltip,
			imgTooltip: imgTooltip,
			imgTooltipPosition: imgTooltipPosition,
			imgTooltipWidth: imgTooltipWidth,
			heightTooltip: (this.props.tooltipHeight && this.props.tooltipHeight !== "") ? this.props.tooltipHeight : heightTooltip,
			heightImg: heightImg,

			fontSizeTitleTooltip: (
				this.props.textTitleTooltipFontSize &&
				this.props.textTitleTooltipFontSize !== ""
			)
				? this.props.textTitleTooltipFontSize
				: fontSizeTitleTooltip,

			fontColorTooltip: (
				this.props.textTitleTooltipFontColor &&
				this.props.textTitleTooltipFontColor !== ""
			)
				? this.props.textTitleTooltipFontColor
				: fontColorTooltip,

			marginTitleTooltip: (
				this.props.textTitleTooltipMargin &&
				this.props.textTitleTooltipMargin !== ""
			)
				? this.props.textTitleTooltipMargin
				: null,

			textSubtitle: textSubtitle,
		});
	};

	onclickCloseTooltip = () => {
		this.setState({ addCloseEfect: true });
		setTimeout(
			function () {
				this.setState({ openToolTip: false });
			}.bind(this),
			900
		);
	};

	onclickModal = () => {
		this.setState({
			openModalTelcel: false,
			titleModalTelcel: "",
			subtitleModalTelcel: "",
			buttonTextTelcel: "Entendido",
		});
		document
			.getElementById("pagoDeServicios_destAccountId_" + this.props.serviceName)
			.focus();
	};

	onclickModalNoPendingAmount = () => {
		this.taggeoArcusSaldoCero("Click Entendido", "Saldo cero");
		this.setState({
			openAlertNoPendingAmount: false,
			titleModalTelcel: "",
			subtitleModalTelcel: "",
			buttonTextTelcel: "Entendido",
		});
	}

	closeSelectCardClaroSocio = () => {
		this.setState({ openSelectCardClaroSocio: false });
	};


	onclickUpdateCard = (event) => {
		this.setState({ openModalUpdateCard: false });
		if (event.target.textContent == "Actualizar ahora") {
			sdkclaro.getInstance().openWallet("openWallet-" + this.state.valueCardId);
		}
	};

	btn1Action = () => {
		this.modalValidationNumberAPTaggeo(
			'Click No',
			this.state.modalValidationNumberAPCase
		);

		this.setState({
			modalValidationNumberAPIsOpen: false
		});

		if (this.state.modalValidationNumberAPCase === 1) {
			if (this.state.itemDistpatchGetAmount) {
				this.props.getAmountOfTelcelPospago(
					this.state.destAccountIdValue,
					this.props.serviceId
				);
				this.setState({ setAmountTelcelPospago: true });
				this.setStepTrack("CS01");
			}
		}

		if (this.state.modalValidationNumberAPCase === 2) {
			this.setState({ destAccountIdValue: '' })
			//document.getElementById("pagoDeServicios_destAccountId_" + this.props.serviceName.trim()).focus();
		}
	}

	btn2Action = () => {
		this.modalValidationNumberAPTaggeo(
			'Click Si',
			this.state.modalValidationNumberAPCase
		);

		// Open microapp
		let microAppId = "";
		switch (this.state.modalValidationNumberAPCase) {
			case 1:
				microAppId = "amigopaguitos"
				break;

			case 2:
				microAppId = "TelcelPospagoPS"
				break;

			default:
				break;
		}

		const url = {
			app: "startEventNoClose",
			to: "openMicroApp",
			parameters: JSON.stringify({
				microAppId: microAppId,
				skipLobby: (this.state.modalValidationNumberAPCase === 2) ? false : true
			}),
		}

		setTimeout(() => {
			sdkclaro.getInstance().openNative(
				JSON.stringify(url),
				() => { },
				() => { },
			)
		}, 1000);

		this.setState({
			modalValidationNumberAPIsOpen: false,
		});
	}

	submitFormToPayTopic = () => {
		const {
			destAccountIdValue,
			valueCardId,
			valueChipProductId,
			valueCvv,
			valueDescription,
			responseCode,
			responseCodeMessage,
			discount,
			commissionData,
			discountCredit,
			inquiryTelmexId,
			dataConfigInputs
		} = this.state;

		const { 
			originOfPayment, serviceId, paramsNewOfferTelcel, serviceInfo,
			tagServiceId, destAccountIdType, feeAmount, serviceName, configImgService,
			trackId, sdkVersion, contactInfo, contactsList, paymentMethods, userInfo,
			userInfoLite, amountPlan
		} = this.props;

		let item = {};
		let categoryId =
			serviceInfo.categoryPlansId == undefined
				? ""
				: serviceInfo.categoryPlansId;
		let paymentMethodIsCredit = valueCardId == CREDIT_CLARO_PAY;

		let cvv = "";
		if (this.state.isAnonimous) {
			cvv = this.props.cvvForAnonimous
		} else {
			cvv = paymentMethodIsCredit ? "" : valueCvv;
		}

		item[`destAccountIdType`] = destAccountIdType;
		item[`serviceId`] = serviceId;
		item["serviceName"] = serviceName;
		item[`feeAmount`] = feeAmount;
		item[`logo`] = configImgService;
		item[`category`] = "MF";
		item[`amount`] = parseFloat(this.context.ocrAmountValue.replace(/,/g, ""));
		item[`productId`] = valueChipProductId;
		item["description"] = valueDescription;
		item["destAccountId"] = destAccountIdValue.replace(/\s+/g, "");
		item["responseCodeMessage"] = responseCodeMessage;
		item["responseCode"] = responseCode;
		item["categoryId"] = categoryId;
		item["transactionId"] = trackId ? trackId : "";
		item["tagServiceId"] = tagServiceId
			? tagServiceId
			: "";
		if (sdkVersion) {
			item["payProcessor"] = paymentMethodIsCredit
				? {}
				: commissionData[0].payProcessor;
			item["discount"] = paymentMethodIsCredit ? discountCredit : discount;
			item["cvv"] = cvv;
			item["totalCommission"] = paymentMethodIsCredit
				? 0
				: this.props.commissionRules[0].totalCommission;
			item["cardId"] = valueCardId;

			if (this.props.isClaroPartner) {
				item["commissionAmountService"] = paymentMethodIsCredit
					? 0
					: this.props.commissionRules[0].commissionByService;
				item["commissionAmountPayMethod"] = paymentMethodIsCredit
					? 0
					: this.props.commissionRules[0].totalPayMethod;
			}
		}
		if (serviceInfo.serviceId === TELMEX) {
			item["inquiryTelmexId"] = inquiryTelmexId;
		}

		const dataContact = contactInfo;
		const contacts = Object.values(contactsList);
		if (
			contactInfo &&
			dataContact.length != 0 &&
			contacts.lengh != 0
		) {
			let contactRecentIsContact = contacts.filter(
				(contact) => contact.displayName == dataContact.fullName
			);
			if (contactRecentIsContact.length > 0) {
				this.props.addContactToRecents(dataContact, serviceId);
			}
		}

		// Provicional para sears

		if (serviceId == 245) {
			const { infoPlanSears, noInternet, searsCardNumber, paymentCard } = this.props;
			const { sequence, paymentNumber } = infoPlanSears;
			item["destAccountId"] = searsCardNumber;
			item["inquiryTelmexId"] = null;
			// item["inquiryTelmexId"] = `${noInternet}|${floatToInteger(
			//   paymentNumber
			// )}|${floatToInteger(sequence)}`;
			item["paymentCard"] = paymentCard;
		}

		const { multipleServiceIds } = this.props;

		if (multipleServiceIds) {
			if (destAccountIdValue.length == multipleServiceIds.ocr.referenceLength) {
				item[`serviceId`] = multipleServiceIds.ocr.serviceId;
			}
			if (
				destAccountIdValue.length == multipleServiceIds.manual.referenceLength
			) {
				item[`serviceId`] = multipleServiceIds.manual.serviceId;
			}
		}

		if (valueCardId != "") {
			let itemCardInfo = paymentMethods.cardList.filter(function (
				item
			) {
				return item.cardId === valueCardId;
			});
			item["cardInfo"] = itemCardInfo[0];
			if (valueCardId == "claro-pay") {
				item["cardInfo"] = { cardId: "claro-pay" };
			}
			if (valueCardId == CREDIT_CLARO_PAY) {
				item["cardInfo"] = { cardId: CREDIT_CLARO_PAY };
			}
			if (valueCardId == ADVANCEMENT_CLARO_PAY) {
				item["cardInfo"] = { cardId: ADVANCEMENT_CLARO_PAY };
			}
		}

		if (serviceInfo.logicType == "claroVideo") {
			item[`productId`] = serviceInfo.productId;
			item["destAccountId"] = userInfo.msisdn.slice(3, 13);
			item["description"] = "Compra Claro Video 1 Mes";
		}

		item[`originOfPayment`] = originOfPayment ? originOfPayment : "Home";
		
		if(this.props.listFavServices !== undefined) {
			let showGuardados = findReference(item["destAccountId"],this.props.listFavServices)
			item['showFavorites'] = showGuardados;
		}
		item['originAppIdPayment'] = tagServiceId
		if(tagServiceId === "serviciopagotelcelMenu" && serviceId === SERVICE_ID_TELCEL_POSPAGO ){
			item['originAppIdPayment'] = paramsNewOfferTelcel ? tagServiceId : TELCEL_POSPAGO_MICROAPP_ID
		}

		if (
			paramsNewOfferTelcel &&
			(serviceId === SERVICE_ID_TELCEL_PLANES) &&
			paymentMethods.hasAdvancement &&
			userInfoLite &&
			userInfoLite.advancePayment &&
			userInfoLite.advancePayment.creditAmount &&
			amountPlan <= userInfoLite.advancePayment.creditAmount &&
			this.state.valueCardId !== ADVANCEMENT_CLARO_PAY
		) {
			item['advancementSnackbar'] = {
				show: true,
				service: this.props.tagServiceId
			}
		}
		item['dataDomiciliation'] = buttonDomiciliationConfigExist(dataConfigInputs) && this.props.hasDmResponse.data || {}
		localStorage.setItem("microappInfo", JSON.stringify({
			serviceId: serviceId,
			paramsNewOfferTelcel: paramsNewOfferTelcel,
			categoryPlansId: serviceInfo.categoryPlansId
		}));
		console.log(JSON.stringify(item), "ENVIADO AL FORM");
		this.props.setPaymentServiceData(item);
		setTimeout(() => {
			this.props.handleShowLoaderWaitSubmit(false);
		}, 2000);
		setTimeout(
			function () {
				this.setState({ buttonState: { disabled: false } });
			}.bind(this),
			500
		);
	};

	handleSubmit = () => {
		let { ocrAmountValue } = this.context;
		let { valueCardId } = this.state;
		this.setState({ buttonState: { disabled: true } });
		let currentAmount = ocrAmountValue.replace(/,/g, "");
		this.getCommissions(valueCardId, String(currentAmount));
		if (
			parseFloat(currentAmount) < AMOUNT_MIN_TO_USE_CREDIT &&
			valueCardId === CREDIT_CLARO_PAY
		) {
			this.setState({ amountMinAlert: true });
			this.deleteItemValidated("isValidAmount");
		} else {
			setTimeout(
				function () {
					this.submitFormToPayTopic();
				}.bind(this),
				1300
			);
			this.taggeo("Click Continuar")
		}
	};

	handleModalClaroOk(event) {
		switch (event.target.textContent) {
			case "Volver a intentar":
				this.setState({
					limitCountPaymentMethodsCall: 4,
					setAmountTelcelPospago: true,
				});
				setTimeout(() => {
					this.props.getAmountOfTelcelPospago(
						this.state.destAccountIdValue,
						this.props.serviceId
					);
					this.setStepTrack("CS01");
				}, 500);
				break;
			case "Salir":
				sdkclaro.getInstance().closeMicroFront();
				break;
			case "Ok":
				sdkclaro.getInstance().closeMicroFront();
				break;
			default:
		}
		this.setState({ openModalCloseMicroApp: false });
	}

	handleModalClaroOkBack() {
		history.back();
		// this.setState({pospagoAlertState: pospagoAlertInitialState});
		// this.setState({openModalCloseMicroApp: false});
		// document.getElementById("pagoDeServicios_destAccountId_" + this.props.serviceName ).focus();
	}

	getImgTypeMessage = (messageType) => {
		switch (messageType) {
			case 0:
				return "data:image/png;base64,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";
			case 1:
				return "data:image/png;base64,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";
			case 2:
				return "data:image/png;base64,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";
		}
	};

	handleSelectPaymentMethodAnonimous = (value) => {
		this.setState({valuePaymentMethodSelectedAnonimous: value});
	}

	handleSetIsOpenAddCardForm = (value) => {
		this.setState({ isOpenAddCardForm: value})
	}

	handleSetFavValue = (value) => {
		this.setState({
			destAccountIdValue: value,
			setDefaultOcrValue: false,
			fromListFavorites: true,
		})
	}

	render() {
		const button = {
			align: {
				center: true,
			},
			weight: {
				bold: true,
			},
			style: {
				normal: true,
			},
		};


		const {
			ocrScannerData,
			isLoadingCommisSionRules,
			commissionRules,
			serviceInfo,
			paramsNewOfferTelcel,
			isContainerTelcel,
			isClaroPartner,
			history,
			dataConfigInputs,
			messages
		} = this.props;
		const {
			setFromOcrScannerData,
			_item,
			valueCardId,
			scanErrorDestAccountIdValue,
			setCommissionRules,
			marginButtonContinue,
			setAutomaticOnclick,
			isAnonimous
		} = this.state;
		setTimeout(() => {
			if (!isLoadingCommisSionRules && commissionRules && setCommissionRules) {
				if (commissionRules[0].cvv == false || this.state.isAnonimous) {
					this.setState({ valueCvv: "" });
					this.addItemValidated("isValidCvv");
				} else {
					if (
						this.state.inputsvalidated.includes("isValidCvv") &&
						this.state.setValueCvv == false
					) {
						this.setState({ valueCvv: "" });
						this.deleteItemValidated("isValidCvv");
					}
				}
				this.setState({
					visibleInputCvv: !this.state.isAnonimous ? commissionRules[0].cvv : false,
					setCommissionRules: false,
					commissionData: commissionRules,
					discount: commissionRules[0].discountArray,
					totalCommission: commissionRules[0].totalCommission,
				});
			}
			if (this.buttonSubmitRef.current) {
				if (
					(paramsNewOfferTelcel && setAutomaticOnclick) &&
					(
						serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE ||
						this.props.serviceId === SERVICE_ID_TELCEL_POSPAGO ||
						(this.props.serviceId === SERVICE_ID_TELCEL_PAQUETES_POSPAGO && serviceInfo.categoryPlansId === CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS)
					) &&
					!isLoadingCommisSionRules
				) {
					this.setState({ setAutomaticOnclick: false })
					this.buttonSubmitRef.current.click()
				}
			}
		}, 150);

		// Validación para escaner
		const { ocrAmountValue, getAmountFromOcrData, setAmountFromInput } =
			this.context;

		let ocrValue = this.props.isClaroPartner
			? ocrScannerData.code
			: ocrScannerData.data;

		if (JSON.stringify(ocrScannerData) != "{}" && setFromOcrScannerData) {
			// Funcionalidad para sacar referencia del codigo de barras
			if (_item.referenceSubstr && _item.referenceSubstr.length == 2) {
				ocrValue = ocrValue.substring(
					_item.referenceSubstr[0],
					_item.referenceSubstr[1]
				);
			}

			if (ocrValue != scanErrorDestAccountIdValue) {
				this.setState({ scanErrorDestAccountIdValue: ocrValue });
				if (handleValidation(ocrValue, _item.constraints[0])) {
					this.setState({ destAccountIdValue: ocrValue });
					this.addItemValidated("isValidOcr");
					this.setState({ isValidOcr: true });
					// Funcionalidad para consultar saldo del codigo de barras
					if (_item.distpatchGetAmount && ocrValue.length == 10) {
						this.props.getAmountOfTelcelPospago(ocrValue, this.props.serviceId);
						this.setState({ setAmountTelcelPospago: true });
						this.setStepTrack("CS01");
					}

					// Funcionalidad para sacar el monto del codigo de barras
					if (_item.amountSubstr) {
						let amount = getValueFromReference(ocrValue, _item.amountSubstr);
						if (
							parseFloat(ocrAmountValue.replace(/,/g, "")) != amount &&
							!setAmountFromInput
						) {
							getAmountFromOcrData(amount);
							amount > 0
								? this.addItemValidated("isValidAmount")
								: this.deleteItemValidated("isValidAmount");
							this.getCommissions(valueCardId, String(amount));
						}
					}
				} else {
					this.setState({ destAccountIdValue: "", isValidOcr: false });
					this.deleteItemValidated("isValidOcr");
					if (_item.amountSubstr || _item.distpatchGetAmount) {
						setTimeout(() => {
							this.deleteItemValidated("isValidAmount");
						}, 200);
						getAmountFromOcrData(0);
					}
				}
			}

			if (
				!handleValidation(ocrValue, _item.constraints[0]) &&
				window.newRequetsScanner &&
				_item.constraintsAlert
			) {
				this.setState({
					scanError: true,
					destAccountIdValue: "",
					isValidOcr: false,
				});
				this.deleteItemValidated("isValidOcr");
				window.newRequetsScanner = false;
				if (_item.amountSubstr || _item.distpatchGetAmount) {
					setTimeout(() => {
						this.deleteItemValidated("isValidAmount");
					}, 200);
					getAmountFromOcrData(0);
				}
			}
		}

		// Validación para montos desde items(tipo telcel recarga)
		let selectedItemId = "";
		if (this.props.selectedChipValues) {
			if (this.props.selectedChipValues.productId != null) {
				selectedItemId = this.props.selectedChipValues.productId;
				if (selectedItemId != this.state.valueChipProductId) {
					this.setState({ valueChipProductId: selectedItemId });
				}
				if (
					this.props.selectedChipValues.amountValue !=
					this.context.ocrAmountValue.toString().replace(/,/g, "")
				) {
					this.context.getAmountFromOcrData(
						this.props.selectedChipValues.amountValue
					);
					if (!this.props.amountPlan && !this.props.paramsNewOfferTelcel) {
						this.addItemValidated("isValidAmount");
					}
				}
			}
		}

		// flujo para consulta de saldo
		if (
			this.props.amountTelcelPospago &&
			this.state.setAmountTelcelPospago &&
			!this.props.isloadingGetAmountTelcelPospago &&
			this.props.responseCheckBalancefrom == "success"
		) {
			let responseCheckBalance = this.props.amountTelcelPospago;
			let image = this.getImgTypeMessage(responseCheckBalance.messageType);
			this.setState({
				titleModalTelcel: responseCheckBalance.responseSubject,
				subtitleModalTelcel: responseCheckBalance.responseMessage,
				imgModalTelcel: image,
				responseCode: responseCheckBalance.responseCode,
				responseCodeMessage: responseCheckBalance.responseMessage,
				setAmountTelcelPospago: false,
				disabledAmountInput: false,
				inquiryTelmexId: responseCheckBalance.inquiryTelmexId
					? responseCheckBalance.inquiryTelmexId
					: this.state.inquiryTelmexId,
			});

			if (
				responseCheckBalance.responseCode == 0 ||
				(this.props.serviceId == TELMEX &&
					responseCheckBalance.responseCode == 15)
			) {
				this.context.getAmountFromOcrData(responseCheckBalance.pendingAmount);
				if (responseCheckBalance.pendingAmount > 0) {
					this.addItemValidated("isValidAmount");
				} else {
					this.deleteItemValidated("isValidAmount");
				}

				this.getCommissions(
					this.state.valueCardId,
					String(responseCheckBalance.pendingAmount)
				);

				if (ARCUS_BILLER_IDS.includes(this.props.serviceId) && responseCheckBalance.pendingAmount == 0) {
					this.taggeoArcusSaldoCero("View alert","Saldo cero")
					this.setState({
						titleModalTelcel: "No hay saldo pendiente para este servicio",
						imgModalTelcel: "/images/status_warning.png",
						openAlertNoPendingAmount: true,
						buttonTextTelcel: "Entendido",
					});
				}
			} else {
				let responseCode = responseCheckBalance.responseCode;
				if (
					(this.props.serviceId == 113 &&
						(responseCode == 803 ||
							responseCode == 805 ||
							responseCode == 809 ||
							(responseCode > 18 && responseCode < 25))) ||
					responseCode == -1
				) {
					if (responseCode === 20) {
						this.setState({
							pospagoAlertState: {
								pospagoAlertText: "¡Ups!",
								pospagoAlertButtonText: "Ok",
								pospagoAlertTextDetail:
									"El número que ingresaste no tiene un plan Telcel y no permite la consulta de saldo. Puedes ir a la sección Recarga de saldo.",
								pospagoAlertTextLink: "",
								pospagoHandleReintent: false,
							},
						});
						this.setState({ openModalCloseMicroApp: true });
					}

					this.context.setCountPaymentMethods(
						this.context.countPaymentMethodsCall + 1,
						this.state.limitCountPaymentMethodsCall
					);
					if (
						this.context.countPaymentMethodsCall <
						this.state.limitCountPaymentMethodsCall &&
						responseCode !== 20
					) {
						this.props.getAmountOfTelcelPospago(
							this.state.destAccountIdValue,
							this.props.serviceId
						);
						this.setState({ setAmountTelcelPospago: true });
						this.setStepTrack("CS01");
					} else {
						if (this.state.limitCountPaymentMethodsCall == 2) {
							this.setState({ openModalCloseMicroApp: true });
						}
						if (this.state.limitCountPaymentMethodsCall == 4) {
							this.setState({ openModalGoToHome: true });
						}
					}
				} else {
					if (responseCode == 18 && this.props.serviceId == 113) {
						this.setState({ disabledAmountInput: true });
						this.setState({
							titleModalTelcel: "¡Ups!",
							subtitleModalTelcel:
								"Al parecer, el número que ingresaste no es Telcel. Favor de verificar.",
							buttonTextTelcel: "Ok",
						});
					}
					if (
						this.props.isClaroPartner &&
						this.props.serviceId === TELMEX &&
						responseCheckBalance.responseCode === 36
					) {
						this.setState({
							errorCode36_TELMEX: {
								...this.state.errorCode36_TELMEX,
								visible: true,
							},
							openModalTelcel: false,
							isValidOcr: false,
						});
					} else {
						this.setState({
							errorCode36_TELMEX: {
								...this.state.errorCode36_TELMEX,
								visible: false,
							},
							openModalTelcel: true,
						});
					}
				}
				this.context.getAmountFromOcrData(0);
				this.deleteItemValidated("isValidAmount");
			}
			const inputTelmex = document.getElementById(
				"pagoDeServicios_destAccountId_TELMEX"
			);
			const amountTelmex = this.context;
			if (amountTelmex.ocrAmountValue > 0) {
				if (
					inputTelmex &&
					inputTelmex.value &&
					inputTelmex.value.length === 10
				) {
					if (this.state.buttonState.disabled) {
						this.context.getAmountFromOcrData(0);
					}
				}
			}
		}

		let contactsValue = this.state.contactsValue;
		if (
			this.props.contactNumber &&
			this.props.contactNumber != this.state.contactsValue &&
			this.state.setContactsValue
		) {
			this.setState({
				setDefaultContactsValue: false,
				contactsValue: this.props.contactNumber,
				destAccountIdValue: this.props.contactNumber,
			});
			if (this.props.selectedChipValues) {
				this.setState({
					valueChipProductId: this.props.selectedChipValues.productId,
				});
			}
			contactsValue = this.props.contactNumber;
			this.addItemValidated("isValidContacts");
		}

		let cardList = this.props.paymentMethods
			? this.props.paymentMethods.cardList
			: [];
		let hasN2 = this.props.paymentMethods
			? this.props.paymentMethods.hasN2
			: false;
		let isCreditPay = this.props.paymentMethods
			? this.props.paymentMethods.isCreditPay
			: false;
		let claroVideoTitleStyle = { align: "center" };
		let claroVideoTitle = "";
		if (this.state.showClaroVideoTitle) {
			claroVideoTitle = (
				<ClaroParagraph
					fontSize="22px"
					{...claroVideoTitleStyle}
					fontFamily="Roboto"
					margin="20px 0px 20px 0px"
				>
					Contrata un mes
				</ClaroParagraph>
			);
		}

		let borderRadiousStyle = this.props.isClaroPartner ? "5px" : "50em";
			borderRadiousStyle = this.props.isContainerTelcel && !this.props.isClaroPartner ? "25px" : borderRadiousStyle;
		let dataCommissions = this.props.commissionRules
			? this.props.commissionRules
			: this.state.commissionData;
		return (
			<>
				<Container os={validateUserAgent()}>
					{
						(
							isContainerTelcel && 
							messages &&
							Object.keys(messages).length > 0 &&
							this.state.isOpenCompleteInformationSnackBar
						) &&
						<Snackbar 
							message={ getMessage(messages, "CP0030", "MiniAppTelcel") }
							isOpenCompleteInformationSnackBar={this.state.isOpenCompleteInformationSnackBar}
							handleIsOpenCompleteInformationSnackBar={this.handleIsOpenCompleteInformationSnackBar}
							executeTaggeo={this.props.executeTaggeo}
							selectPaymentServiceConf={this.props.selectPaymentServiceConf} />
					}					
					{claroVideoTitle}
					{Object.entries(this.state.dataConfigInputs).map((input, key) => {
						let newItem = {};
						switch (input[1].type) {
							case "buttonBox":
								return (
									<ButtonBoxContainer 
										input={input[1]}
										isContainerTelcel={this.props.isContainerTelcel}
										amount={this.context.ocrAmountValue} 
										accountValue={this.state.destAccountIdValue}
										accountValueValidLength={this.state.itemDistpatchGetAmountLength} 
										serviceId={this.props.serviceId}
										handleInputButtonFunction = {this.handleInputButtonFunction}
										history= {history}
										tagServiceId={this.props.tagServiceId}
										configImgService={this.props.configImgService}
										handleSetFavValue={this.handleSetFavValue}/>
								)
							case "card":
								break;
							case "commission":
								if (this.props.sdkVersion !== undefined && !this.props.productIdFromUrl) {
									return (
										<CommisionModule
											commissionData={dataCommissions}
											cardId={this.state.valueCardId}
											key={key}
											amount={this.context.ocrAmountValue}
											isClaroPartner={this.props.isClaroPartner}
											logicType={this.props.serviceInfo.logicType}
											paymentType={this.props.paymentType}
											serviceId={this.props.serviceId}
											isContainerTelcel = {isContainerTelcel}
										/>
									);
								}
								break;
							case "ocr":
								if (this.state.errorCode36_TELMEX.visible) {
									input[1] = {
										...input[1],
										subTitle: this.state.errorCode36_TELMEX,
									};
								}
								newItem = {
									input: input[1],
									serviceInfo:this.props.serviceInfo,
									handleInputChange: this.handleInputChange,
									value: this.state.destAccountIdValue,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidOcr,
									setDefaultValue: this.state.setDefaultOcrValue,
									isClaroPartner: this.props.isClaroPartner,
									serviceId: this.props.serviceId,
									favoritos:  existConfigFavorites(dataConfigInputs),
									configImgService:this.props.configImgService,
									isContainerTelcel: isContainerTelcel,
									fromListFavorites: this.state.fromListFavorites,
								};
								return <DefaultInputClaroSocio {...newItem} key={key} />;
							case "contacts":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: contactsValue,
									inputValue:this.state.destAccountIdValue,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									serviceId: this.props.serviceId,
									isValid: this.state.isValidContacts,
									setDefaultValue: this.state.setDefaultContactsValue,
									isClaroPartner: this.props.isClaroPartner,
									favoritos: existConfigFavorites(dataConfigInputs),
									serviceTA: this.props.serviceInfo.serviceTA,
									isContainerTelcel: isContainerTelcel
								};
								return <ContactInputClaroSocio {...newItem} key={key} />;
							case "select":
								if (this.props.sdkVersion !== undefined) {
									newItem = {
										input: input[1],
										handleInputButtonFunction: this.handleInputButtonFunction,
										value: this.state.valueSelectInput,
										mark: this.state.mark,
										setDefaultValue: this.state.setDefaultSelectValue,
										isClaroPartner: this.props.isClaroPartner,
										logicType: this.props.serviceInfo.logicType,
										isContainerTelcel: isContainerTelcel
									};
									return <SelectInputClaroSocio {...newItem} key={key} />;
								}
								break;
							case "select-chips":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									handleInputClick: this.handleInputClick,
									selectedItemId: selectedItemId,
									planInformationQuery:
										this.props.serviceInfo.planInformationQuery,
								};
								if (this.props.isClaroPartner) {
									if (this.props.serviceInfo.planInformationQuery) {
										if (this.props.plans) {
											return (
												<ChipInputClaroSocio
													{...newItem}
													key={key}
													plans={this.props.plans}
												/>
											);
										}
									} else {
										return <ChipInputClaroSocio {...newItem} key={key} />;
									}
								} else {
									if (this.props.serviceInfo.planInformationQuery) {
										if (this.props.plans) {
											return (
												<ClaroChipsBlock key={key} {...newItem} plans={this.props.plans} isContainerTelcel={isContainerTelcel} />
											);
										}
									} else {
										return <ClaroChipsBlock key={key} {...newItem} isContainerTelcel={isContainerTelcel} />;
									}
								}

							case "button":
								let disableValue = false;
								let margin = "6% 4% 0% 4%";
                                let float = undefined;
								if (input[1].id == "boton1") {
									disableValue = true;
									let referenceInput = _.find(this.props.dataConfigInputs, [
										"id",
										"destAccountId",
									]);
									if (
										referenceInput.field.input.truncateValue ==
										this.state.destAccountIdValue.length
									) {
										disableValue = false;
									}
									margin = isContainerTelcel && !this.props.isClaroPartner 
										? "17px 0px 30px 8px" 
										: margin

									float = isContainerTelcel && !this.props.isClaroPartner 
										? "left" 
										: float
								}

								if (input[1].id == "boton2") {
									margin = isContainerTelcel && !this.props.isClaroPartner 
											? "17px 8px 30px 0px" 
											: margin
									
									float = isContainerTelcel && !this.props.isClaroPartner 
											? "right" 
											: float
								}
								if(isContainerTelcel ){
									return (
										<ClaroButton
											width={!isContainerTelcel ? "42%!important" : "45%"} 
											backgroundColor="#ffffff"
											onClick={(e) =>
												this.handleInputClick(e, input[1].onclickAction)
											}
											color={!isContainerTelcel ? "#50626b!important" : "#7b1fa2!important"}
											border="solid"
											borderColor={!isContainerTelcel ? "#eeeeee" : "#7b1fa2"}
											lineHeight="normal!important"
											height="auto"
											margin={margin}
											key={key}
											disabled={disableValue}
											padding = {isContainerTelcel ? '9px 0px 7px 0px' : undefined}
											fontFamily = {isContainerTelcel ? 'AMX-Bold' : undefined}
											fontSize = {isContainerTelcel ? '13px' : undefined}
											float={float}
											isContainerTelcel={isContainerTelcel}
											cancelStylesDisabled={isContainerTelcel ? true : false}
										>
											{input[1].title.text}
										</ClaroButton>
									);
								}else{return ""}
							case "cvv":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: this.state.valueCvv,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidCvv,
									visible: this.state.visibleInputCvv,
									isClaroPartner: this.props.isClaroPartner,
									logicType: this.props.serviceInfo.logicType,
									handleClickScroll: this.props.handleClickScroll,
									isContainerTelcel: this.props.isContainerTelcel,
									serviceTA: this.props.serviceInfo.serviceTA,
								};
								return (
									<CvvInputClaroSocio
										{...newItem}
										key={key}
										serviceId={this.props.serviceId}
									/>
								);
							case "description":
								newItem = {
									input: input[1],
									handleInputChange: this.handleInputChange,
									value: this.state.valueDescription,
									handleClickTooltip: this.handleClickTooltip,
									serviceName: this.props.serviceName,
									handleInputButtonFunction: this.handleInputButtonFunction,
									isValid: this.state.isValidDescription,
									logicType: this.props.serviceInfo.logicType,
									handleClickScroll: this.props.handleClickScroll,
									isClaroPartner: this.props.isClaroPartner,
                                    isContainerTelcel: isContainerTelcel
								};
								return <DescriptionInputClaroSocio {...newItem} key={key} />;
							default:
								if (input[1].id == "amount") {
									if (
										this.state.setDefaultAmount &&
										input[1].field.input.value != "" &&
										input[1].field.input.value != undefined &&
										this.context.ocrAmountValue != input[1].field.input.value
									) {
										this.context.getAmountFromOcrData(
											input[1].field.input.value
										);
									}

									newItem = {
										input: input[1],
										handleInputChange: this.handleInputChange,
										value: this.context.ocrAmountValue,
										serviceName: this.props.serviceName,
										isClaroPartner: this.props.isClaroPartner,
										amountPlan: this.props.amountPlan,
										logicType: this.props.serviceInfo.logicType,
										disabledAmountInput: this.state.disabledAmountInput,
										userAgentIsAndroid: validateUserAgent() === "android",
										serviceId: this.props.serviceId,
										isDisabledButtonArcusGetAmount: this.state.isDisabledButtonArcusGetAmount,
										handleInputButtonFunction: this.handleInputButtonFunction,
										dataConfigInputs: this.props.dataConfigInputs,
										handleInputClick: this.handleInputClick,
										canManageFavorites: this.props.canManageFavorites
									};
									return <AmountInputClaroSocio {...newItem} key={key} isContainerTelcel={isContainerTelcel} />;
								} else {
									newItem = {
										input: input[1],
										handleInputChange: this.handleInputChange,
										value: "",
										handleClickTooltip: this.handleClickTooltip,
										serviceName: this.props.serviceName,
										handleInputButtonFunction: this.handleInputButtonFunction,
										serviceId: this.props.serviceId
									};
									return <DefaultInputClaroSocio {...newItem} key={key} />;
								}
						}
					})}
					<ClaroPadding padding={(this.props.isContainerTelcel)?'30px 2% 2% 2%':'2%'} style={{marginBottom:"20px"}}>
						<ClaroParagraph
							{...button.align}
							{...button.weight}
							{...button.style}
							style={{ margin: marginButtonContinue, paddingBottom: "10px" }}
						>
							{this.props.isLoadingCommisSionRules ||
								this.props.isloadingGetAmountTelcelPospago ? (
								<ClaroLoadBtn backgroundColor="#000000" disabled isContainerTelcel={isContainerTelcel}></ClaroLoadBtn>
							) : (
								<ClaroButton
									id="claro_button"
									backgroundColor={isContainerTelcel ? "#7b1fa2" : "#000000"}
									{...this.state.buttonState}
									onClick={this.handleSubmit}
									borderRadiusClaro={borderRadiousStyle}
									isClaroPartner={this.props.isClaroPartner}
									innerRef={this.buttonSubmitRef}
									fontFamily={isContainerTelcel ? "AMX-Bold" : "RobotoBold"}
                                	isContainerTelcel={isContainerTelcel}
								>
									{this.state.buttonText}
									{serviceInfo.logicType === "sears" ? (
										<img
											src={"./images/path_continuar_blanca.svg"}
											style={{
												margin: "0px 0px 2px 5px",
												verticalAlign: "middle",
											}}
										/>
									) : (
										""
									)}
								</ClaroButton>
							)}
						</ClaroParagraph>
					</ClaroPadding>
				</Container>
				<ModalValidationNumberAP
					isOpen={this.state.modalValidationNumberAPIsOpen}
					backgroundColor='rgba(0,0,0,0.1)'
					titleText={this.state.modalValidationNumberAPTitle}
					subtitleText={this.state.modalValidationNumberAPSubtitle}
					btn1Background='#fff'
					btn1Color={isContainerTelcel ? '#7b1fa2' : '#000'}
					btn1Text={this.state.ModalValidationNumberAPBtn1Text}
					btn1Action={this.btn1Action}
					btn2Background={isContainerTelcel ? '#7b1fa2' : '#000'}
					btn2Color='#fff'
					btn2Text={this.state.ModalValidationNumberAPBtn2Text}
					btn2Action={this.btn2Action}
					isContainerTelcel={isContainerTelcel}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ClaroTooltip
					closeImg={isContainerTelcel ? '/images/icono_salir_contenedor.png' : undefined}
                    fontFamilyTitle={isContainerTelcel ? "AMX-Bold" : undefined}
                    fontFamilySubtitle={isContainerTelcel ? "AMX-Regular" : undefined}
					isOpen={this.state.openToolTip}
					addCloseEfect={this.state.addCloseEfect}
					onclickCloseTooltip={this.onclickCloseTooltip}
					text={this.state.textTitleTooltip}
					srcImage={this.state.imgTooltip}
					srcImagePosition={this.state.imgTooltipPosition}
					marginTitle={this.state.marginTitleTooltip}
					heightImg={this.state.heightImg}
					colorButton="#797878"
					fontSizeTitle={this.state.fontSizeTitleTooltip}
					height={this.state.heightTooltip}
					colorTitle={this.state.fontColorTooltip}
					fontSizeButton="23px!important"
					fadeInTime="1s"
					fadeIn
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					widthImg={this.state.imgTooltipWidth}
					textSubtitle={this.state.textSubtitle}
					colorSubtitle={isContainerTelcel ? "#000000" : "#838383"}
					fontWeightTitle="bold!important"
					fontWeightSubtitle="normal!important"
					fontSizeSubtitle="12px"
					paddingTitle="3px 16px 0px 16px"
					marginButton="0px 0px 0px 0px"
					boxShadow="none"
				/>
				<ModalCardLoader
					isOpen={
						this.props.showLoaderWaitSubmit || 
						(this.props.isLoadingGetPaymentMethods || this.props.isLoadingGetFavServices ||
						(
							(
								paramsNewOfferTelcel && paramsNewOfferTelcel.cvv &&
								setAutomaticOnclick && this.props.serviceId !== SERVICE_ID_TELCEL_RECARGA
							) ||
							(
								paramsNewOfferTelcel &&
								this.props.isloadingGetAmountTelcelPospago
							) ||
							(
								paramsNewOfferTelcel &&
								this.props.isLoadingCommisSionRules
							)
						))
					}
				/>
				<SelectCardClaroSocio
					backgroundColor="rgba(0,0,0,0.8)"
					isOpen={
						!this.props.isLoadingGetPaymentMethods &&
						this.state.openSelectCardClaroSocio
					}
					colorButton="#797878"
					height="70%"
					fontSizeButton="23px!important"
					marginButton="0px 0px 0px 10px"
					fadeInTime="1s"
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					fadeIn
					addCloseEfect={false}
					cardItems={cardList}
					hasN2={hasN2}
					closeSelectCardClaroSocio={this.closeSelectCardClaroSocio}
					handleInputClick={this.handleInputClick}
					selectValue={this.state.valueCardId}
					activeN2={this.validateActiveN2()}
					isCreditPay={isCreditPay}
					isClaroPartner={this.props.isClaroPartner}
          isContainerTelcel={this.props.isContainerTelcel}
					showAdvancementPayMethodInList={this.props.showAdvancementPayMethodInList}
					executeTaggeo={this.props.executeTaggeo}
				/>
				<SelectCardAnonimous 
					height="75%"
					backgroundColor="rgba(0,0,0,0.1)"
					isOpen={
						this.state.openSelectCardAnonimous
					}
					fadeInTime="1s"
					cubicBezier="cubic-bezier(0.9, 0, 0.9, 1)"
					fadeIn
					addCloseEfect={false}
					handleCloseSelectCardAnonimous={() => this.setState({ openSelectCardAnonimous: false })}
					handleInputClick={this.handleInputClick}
					planCategory={this.props.planCategory}
					planBenefits={this.props.planBenefits}
					handleOpenModalCardHE={() => this.setState({isOpenModalCardHE: true})}
					handleValidateIfSentToTicket={this.props.handleValidateIfSentToTicket}	
					handleShowLoaderWaitSubmit={this.props.handleShowLoaderWaitSubmit}	
				/>
					
				<ModalCardOk
					isOpen={this.state.openAlertNoPendingAmount}
					paddingCard="0px 30px 0px 30px"

					srcImage={this.state.imgModalTelcel}
					imageMargin="20px 0px 16px 0px"
					heightImg="56"
					widthImg="56"
					onClickImg={()=>false}

					text={this.state.titleModalTelcel}
					fontFamilyTitle="RobotoMedium"
					fontSizeTitle="20px"
					colorTextModal1="#1e1e1e"
					marginTitle="0px 0px 32px 0px"
					fontWeightTitle="normal"

					buttontext={this.state.buttonTextTelcel}
					widthButton="200px"
					marginButton="0px auto"
					fontFamilyButton="RobotoBold"
					colorButton="#fff"
					backgroundColorButton="#000"
					fontSizeButton="16px"

					onclickModal={this.onclickModalNoPendingAmount}
				/>
				<ModalCardOk
					isOpen={this.state.openModalTelcel}
					srcImage={this.state.imgModalTelcel}
					text={this.state.titleModalTelcel}
					textdetail={this.state.subtitleModalTelcel}
					buttontext={this.state.buttonTextTelcel}
					onclickModal={this.onclickModal}
					onClickImg={this.onclickModal}
					fontSizeDetail="12px"
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : '#202020'}
					fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ModalCardOk
					isOpen={this.state.openModalUpdateCard}
					srcImage="data:image/png;base64,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"
					text="¡Hey!"
					buttontext="Actualizar ahora"
					textdetail="Es necesario que actualices los datos de esta tarjeta para que puedas utilizarla"
					onclickModal={this.onclickUpdateCard}
					textLink="Hacerlo en otro momento"
					textDecorationLinkButton="underline"
					fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
					fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					marginButton={isContainerTelcel ? "0 auto 28px auto" : undefined}
					fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					textSizeLinkButton={isContainerTelcel ? "16px" : "10px"}
					fontFamilyLinkButton={isContainerTelcel ? 'AMX-Bold' : "RobotoBold"}
					textColorLinkButton={isContainerTelcel ? "#0071d1" : "#000"}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ModalCardOk
					isOpen={this.state.openModalCloseMicroApp}
					srcImage="data:image/png;base64,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"
					text={this.state.pospagoAlertState.pospagoAlertText}
					buttontext={this.state.pospagoAlertState.pospagoAlertButtonText}
					textdetail={this.state.pospagoAlertState.pospagoAlertTextDetail}
					onclickModal={
						this.state.pospagoAlertState.pospagoHandleReintent
							? (e) => {
								this.handleModalClaroOk(e);
							}
							: () => {
								this.handleModalClaroOkBack();
							}
					}
					textLink={this.state.pospagoAlertState.pospagoAlertTextLink}
					textDecorationLinkButton="underline"
					fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
					fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					textSizeLinkButton={isContainerTelcel ? "16px" : "13px"}
					fontFamilyLinkButton={isContainerTelcel ? 'AMX-Bold' : "RobotoBold"}
					textColorLinkButton={isContainerTelcel ? "#0071d1" : "#000"}
					marginButton={isContainerTelcel ? "0 auto 28px auto" : undefined}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
                	marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				<ModalCardOk
					isOpen={this.state.openModalGoToHome}
					srcImage="data:image/png;base64,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"
					text={"¡Lo sentimos!"}
					buttontext={"Ok"}
					textdetail={
						"Por el momento este servicio no está disponible. Por favor, intenta más tarde."
					}
					onclickModal={(e) => {
						this.handleModalClaroOk(e);
					}}
					fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
					colorTextModal1={isContainerTelcel ? '#222222' : undefined}
					fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
					fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
					backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
					fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
					fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
					fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
					colorTextdetail={isContainerTelcel ? "#757575" : undefined}
					marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
				/>
				{
					<ModalCardOk
						isOpen={this.state.scanError}
						srcImage="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEEAAABBCAYAAACO98lFAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAQaADAAQAAAABAAAAQQAAAAD8l6BDAAAIi0lEQVR4Ae1ba4hVRRz/z727q67rqmhprpqPtDDCQNF8RGZl0GP9oBkWSVSYQgVZX/pQH6KPaWCBi1CBUpHZB7cXWZmQjxSLIpKSTMtHYkqurqvu457+v5k7c86ZPWf3PmauwvqDe8/858yd/+POzJnH7xBdBYlKxiDY9FCWBvw7lLKZwZSp7s+6+1EuU0OZXDunL1Gu4yJ15VrowjX/iSUfdVXKNq9BCD6fOZq6gvnszHwKxBwKaDxRkO3dOdHFf88hEsFOLruNsmKbuG/P0d5/V1oJ50EIvp03hM61PUwkHqMgmFOaWQm/EoIDEmykQbUfiju3n0koUXKWsyAEn8xqoCD3Ihu6nP/x2kSLRIao9jqigWOIagYTVXGxLPeKrotEnW1E7S1E548Qtf3D1eQSq+AWwgXFehKZ18WDu48lFyout+wgcJOvpw56la1eyaprYuozVUTDp4ef+huIx4JYkUQh10F09g+iU/vCT67TLsrjiFhH1fQKd5Wz9s1i5LKCEDTPWMrK1vA/PzKmdPBkorGNRKPvJaquj90qSUALObaV6O9mopYD8SoEneCMVaJx7wfxG4VLJQUh2Le8mo79tJbVrIipGthAdBNnNSyIZTsVEIzfmrjbdOsJTdRw63Ni+npuRsWh6CAEX981jNpaN/OgN8+oQv+e/ATR+MXcQrkL+EbAXePQZqID76hxROsTYjvV1i0Wd39zWmcVci0qCEHznJuJOpq5+U8wlY+5n+iWF3iQG2iyKpboPE/0y2qiI5+FKgX9yX2wUTTu/DXM7DlVcBCCLTPv4ao+5gFwkKwSI/2UZ4gmPtqzhkrcPfge0f63Ik8UcY7VLhIL93xViPqCgiBbQNC52wSguo5o2mtE184qREdlypzcRfTDy9xQW/P6OBCialYhLaLXIKgx4Nxe0wVqRxHd9gZR3bjKOFeMltbDRN8/z/OM4+pX6Bq1g2b0NkZwm06HfArIQTA/BqAFuAoA5gId/HjXHwx25QJ/DOyDnQDGLrZf+qFyEr97bAnBlhnr+FfqMYgxYOZq7gKzEysqKrPld6Ldz8ZHdjxhZnO/ruc5RrlA19jDg3U462wSC/diMpeI1JaQnwiF84ApbLSLAMCMkzy8YAIUBeQTO6I5padhJwbtECvy/oQ5kVRiEORUGDNBDTwGJz6ipfKvaVPnbL/y69Y14KkFu0OsyfsV5uRTiUGQawE9FUYzxTzAJdLmFGn5peqG3bAfgD9yjaPE6He3IMjVoFoMqXI3Pul+IoTVYxLS8pPKFpKHoMJ+g2Cl8s9kyES3IKjlcH41iLXAuEXxX7iQqlNml2n55eiE/fBDoSbvn5blNRaE4NO5Q7ndLDclsBjysRZIa/Zp+cagEhKwH34YBMvlxo+ReXUfSRPl2pdw31FtFcthX6vBNGfT8mNGliDAD/gDwD+586VEfMeDENAyc+v6hSbpPJHmbFq+CwOwv2HAW38RmCDITVGersh72BHy1QqgIM3ZtPyIwSUnscEDvwDe+8z7K0UThPyusMyUW2IudoRUbd2/0wbAtPzuNRSfA3+w1aehdsGlFAYB2+Ia0cI6z+UVg5U9YYLsYxCO2h33y/gbBgHnAhrxwjrX7dX+123ZrTZV2/BpYa0Rf2UQ5MmQPBjhMlgoYVfYN+z+b8s+9NdPUv6hbvaXH5VykFAtAUdj+mQI5wJ2U/VhkO20LfvQCb/gnwSfhLXRcCRVEHA2qIGDkUrAdtqWfdkQ9a9LDIMaFYRc1QCjUy84TIanhO20LXtSaxZUqD+r/FZBqBI1RqfrRYyp2ErYemzZKu5MjOrJBP1Rb74l8PG4Bs4GKwH7aWDLvmyI+pepln6rICh+gFKLw9FKwG7+tuzLhqh/uY52qFFBAEFCA6fDlUC0WUKfLfuyIepfpusC1OS7AzNENOy9P53v+mr/87bsWp+uL+rfJZJ+qyCAIqMBfkAlYI8BtuzLhqh/2eA01KggMEeIp1JdUi8IEjgT8I2stcVWiZYAv+CfBPtbS6eQlEGQJClwhADs1YMg4Rv6gETrqUQQ4Jc+i2B/mfYjT3xUS4AhiiSlTAJDxDdsp23Zh/6oXxF/wyCAJaYRLazzXF9tp23ZtT7UF/fL+BsGgWlyRi8K44zQJ/rxmg0rVgBXyD4Bf6JBiPhrgpDnCe6SdoAkBVqMT9QM4V3gp9UGKK6QfeLolzzgyyGAgy52RnmRJghSv6ANxo6/tpikt8Skx4nu2EiEq2+A9GXAfMgI4kHI1GxSPEEuAZaY79YQMcRrEn7AHwA8SCaEKkF9x4IgHtiB+cJ6UwAsMRe8AVPhZUjAfvhhINbbjNhYEGQ5ZorytV2mQZMDS8wXzjC3Cgb6bHGwP6T7tYMJa7vTLQiKKstMUQ3Q5MASc43TPxJ99xTT8N5VXKP9a11rUHbDfgOxLokK3C0IsjxTZbnvnJBpLDhAk3MNjNZ69oa6j3zhWoOyWy+Y4A/8SkBiEPJc4VWmPHiCoMm5RO3IeG0DRsTlciXYG+U3gvqbwoFODAL057nC4YgCniBoNq4wYSnRiLmsiE2oG0s09SVXNSs7YW+Ipp64zz0Tt8BhPv7zVkPhxaLn9rfd0vcwers8eWo9zGMNEzM0nxFU31FTF/TEee4xCAhkn+cxIgiKCFnN59qSKquIkog0aHJXEmAP7NJETmkvc5wLIHv32hK0n8ncZqb1uWS1aWXFXg++z9zmNyNPGw/cZm1Tn2e5m0Ckve8AlhhIUi4HOa3UvmIwvVzvO2hb+vybLzoQuPb4DhQ4T6D8uGC8YEMEM8wr6R2oWCD6+ttwsWD05fcio4FAWhJCFR9yGYuz7ftlyLt4Ubfhin5DNsk5SZPri+9KJwVD50mOECgyYIiAIAF+AI7HcTqcE/zGfOcFwtEYnwzpgxH926tXzxH4H5XW3qAaXYTFAAAAAElFTkSuQmCC"
						text={"¡Ups!"}
						buttontext={"Ok"}
						textdetail={
							"Código inválido. Por favor verifica e inténtalo de nuevo"
						}
						onclickModal={() => this.setState({ scanError: false })}
						fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
						colorTextModal1={isContainerTelcel ? '#222222' : undefined}
						fontFamilyTextdetail={isContainerTelcel ? "AMX-Regular" : undefined}
						fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
						backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
						fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
						fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
						fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
						colorTextdetail={isContainerTelcel ? "#757575" : undefined}
						marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
						marginTextDetail={isContainerTelcel ? "0px 0px 30px 0px" : undefined}
					/>
				}
				{
					<ModalCardOk
						isOpen={this.state.amountMinAlert}
						srcImage="data:image/png;base64,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"
						text={
							"Para poder usar tu crédito necesitas pagar una factura con un monto mínimo de  $" +
							formatToCurrency(AMOUNT_MIN_TO_USE_CREDIT)
						}
						buttontext={"Entendido"}
						onclickModal={() => this.setState({ amountMinAlert: false })}
						fontSizeTitle={isContainerTelcel ? '20px' : '26px'}
						fontFamilyTitle={isContainerTelcel ? 'AMX-Bold' : undefined}
						colorTextModal1={isContainerTelcel ? '#222222' : undefined}
						backgroundColorButton={isContainerTelcel ? '#7b1fa2' : undefined}
						fontFamilyButton={isContainerTelcel ? 'AMX-Bold' : ''}
						fontSizeButton={isContainerTelcel ? '16px' : '4.05vw '}
						marginTitle={isContainerTelcel ? "0px 0px 20px 0px" : undefined}
					/>
				}

				<ModalCardHE 
					isOpen={this.state.isOpenModalCardHE}
					close={()=>this.setState({isOpenModalCardHE: false})}
				/>
			</>
		);
	}
}

BodyPaymentFormClaroSocio.contextType = GenericFormContext;

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			getPaymentMethods,
			getAmountOfTelcelPospago,
			setSelectedChipValues,
			getCommissionInfo,
			addContactToRecents,
			setCreditCardInfo,
			getPlans,
			setTrackSteps,
			getOCRScanner,
			executeTaggeo,
			setIsAnonimous,
			setReloadInfoAfterAddingCard,
			getHasDomiciliation,
			setShowAdvancementMiniBanner,
			setAdvancementPayMethod,
			setPaymentMethod
		},
		dispatch
	);
}

function mapStateToProps(state) {
	const { payments, domiciliationReducer:{hasDomiciliationServiceResponseSuccess} } = state;
	const contactsList = selectPaymentServiceContacts(payments);
	const ocrScannerData = selectOCRScannerData(payments);
	const canSendId = getCanSendId(state);
	const hasCredit = getHasCreditFromUrl(state);
	const bundleVersion = getBundleVersionFromUrl(state);
	const userInfo = getUserInfoSelector(state)
	const userInfoLite = getUserInfoLiteSelector(state);
	const isAnonimous = payments.isAnonimous;
	const reloadInfoAfterAddingCard = payments.reloadInfoAfterAddingCard;
	const addCardFormData = payments.addCardFormData;
	const {setAdvancementPayMethodValue, messages, cvvForAnonimous} = payments
	return {
		selectPaymentServiceConf: selectPaymentServiceConf(state.payments),
		paymentMethods: state.payments.paymentMethods,
		ocrScannerData,
		isLoadingGetPaymentMethods: state.payments.isLoadingGetPaymentMethods,
		isloadingGetAmountTelcelPospago:
			state.payments.isloadingGetAmountTelcelPospago,
		isLoadingCommisSionRules: state.payments.isLoadingCommisSionRules,
		isLoadingGetFavServices: state.favoritesRefReducer.isLoading,
		commissionRules: state.payments.commissionRules,
		amountTelcelPospago: state.payments.amountTelcelPospago,
		selectedChipValues: state.payments.selectedChipValues,
		userInfo: userInfo,
		contactsList,
		contactInfo: state.payments.contactInfo,
		creditCardInfo: state.payments.cardInfo,
		plans: state.payments.plans,
		isLoadingGetPlans: state.payments.isLoadingGetPlans,
		errorCheckBalance: state.payments.errorCheckBalance,
		responseCheckBalancefrom: state.payments.responseCheckBalancefrom,
		trackId: state.payments.trackId,
		activeN2: state.payments.activeN2,
		canSendId,
		hasCredit,
		lineNumber: payments.lineNumber,
		originOfPayment: payments.originOfPayment,
		bundleVersion: bundleVersion,
		userInfoLite: userInfoLite,
		setPaymentMethodInfo: payments.setPaymentMethodInfo,
		paymentAmountFromUrl: payments.getPaymentAmountFromUrl,
		productIdFromUrl: payments.getProductIdFromUrl,
		isAnonimous,
		reloadInfoAfterAddingCard,
		addCardFormData,
		isTemporalClaroId: payments.isTemporalClaroId,
		hasDmResponse : hasDomiciliationServiceResponseSuccess,
		setAdvancementPayMethodValue,
		messages,
		cvvForAnonimous
	};
}

BodyPaymentFormClaroSocio = connect(
	mapStateToProps,
	mapDispatchToProps,
	
)(BodyPaymentFormClaroSocio);

export default BodyPaymentFormClaroSocio;
